(() => {
  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try { await navigator.clipboard.writeText(text); return; } catch (_) { /* Try manual copy support. */ }
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try { if (!document.execCommand('copy')) throw new Error('Copy failed'); }
    finally { textarea.remove(); }
  };

  const initialize = () => document.querySelectorAll('[data-rg-news-share]').forEach((share) => {
    if (share.dataset.initialized === 'true') return;
    share.dataset.initialized = 'true';
    const url = share.dataset.shareUrl || window.location.href;
    const message = share.querySelector('[data-share-message]');
    share.querySelector('[data-share-copy]')?.addEventListener('click', async () => {
      try { await copyText(url); if (message) message.textContent = '記事のリンクをコピーしました。'; }
      catch (_) { if (message) message.textContent = 'リンクをコピーできませんでした。ブラウザーのアドレス欄からコピーしてください。'; }
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
